import { useHome } from "@/pages/home/useHome";
import { HomeContainer, OrderContainer, ToggleContainer } from "./style";
import {
  Divider,
  ZenAccordion,
  ZenInput,
  ZenTag,
  ZenToggle,
  OrderFastScroller,
  ModalContainer,
  Button,
} from "@/components";
import { SearchIcon } from "@/assets/Icons";
import { getMedalEmoji } from "@/utils/customerClassification";

export function Home() {
  const {
    orderList,
    isLoadingList,
    clientProfile,
    handleSearch,
    handleOpenModal,
    handleOpenEditModal,
    mappingEntries,
    showIncomplete,
    handleToggleIncomplete,
    documents,
    customerTier,
    conversation,
    showCpfConfirm,
    classificationStatus,
    handleConfirmCpfFill,
    handleCloseCpfConfirm,
    handleFillClassification,
    searchLoading
  } = useHome();
  return (
    <HomeContainer>
      <h1>Bem-vindo! ao VTEX!</h1>
      <ToggleContainer>
        <p>consulte pedidos não faturados/incompletos</p>
        <ZenToggle checked={showIncomplete} onChange={handleToggleIncomplete} />
      </ToggleContainer>

       <ZenInput
         label="Pesquisar"
         placeholder={"Buscar por nome, CPF, e-mail..."}
         start={<SearchIcon />}
         onChange={handleSearch}
         disabled={searchLoading}
       />

      {!isLoadingList && orderList.length === 0 && (
        <h4>Nenhum pedido encontrado.</h4>
      )}
      {searchLoading && <h4>Carregando...</h4>}

      {clientProfile && (
        <ZenAccordion
          title="Dados do usuário"
          labels={[
            "E-mail", "Nome", "CPF", "Total de pedidos",
            "Total gasto",
            "Total gasto (6 meses)",
            "Classificação",
          ]}
          values={[
            (documents || []).map((doc) => doc.email).find((e) => !!e) || conversation[0]?.to[0].email || clientProfile.email,
            `${clientProfile.firstName} ${clientProfile.lastName}`.trim(),
            clientProfile.document,
            orderList.length,

            `R$ ${(
              orderList
                .filter(o => o.status !== 'canceled')
                .reduce((total, item) => total + item.totalValue, 0) / 100
            ).toFixed(2)}`,

            customerTier ? `R$ ${customerTier.totalSpent.toFixed(2)}` : "R$ 0,00",

            customerTier ? `${getMedalEmoji(customerTier.medal)} ${customerTier.medal}` : "N/A",
          ]}
        />
      )}
      {clientProfile && (
        <Button
          isPrimary
          onClick={handleFillClassification}
          disabled={classificationStatus === 'loading'}
        >
          {classificationStatus === 'success'
            ? '✅ Classificação importada com sucesso!'
            : 'Importar classificação para o solicitante'}
        </Button>
      )}
      {mappingEntries.length > 0 && (
        <>
          <Divider />
          <ZenAccordion
            title="Campos VTEX"
            labels={mappingEntries.map((e) => e.zendeskTitle)}
            values={mappingEntries.map((e) => e.value)}
            button={{ label: "Configurar campos", link: handleOpenEditModal }}
          />
        </>
      )}

      {(isLoadingList || orderList.length > 0) && clientProfile && (
        <>
          <Divider />
          <OrderContainer>
            <h3>Últimos pedidos</h3>
            <OrderFastScroller
              items={orderList}
              getDate={(item) => item.creationDate}
              showIndex={false}
              renderItem={(item, index) => (
                <ZenAccordion
                  key={item.orderId}
                  title={`Pedido #${index + 1}`}
                  labels={["Pedido", "Cliente", "Status", "Data"]}
                  values={[
                    item.orderId,
                    item.clientName,
                    <ZenTag label={item.statusDescription} hue="green" />,
                    new Date(item.creationDate).toLocaleDateString("pt-BR"),
                  ]}
                  isLoading={isLoadingList}
                  button={{
                    label: "Ver mais",
                    link: () => handleOpenModal(item.orderId),
                  }}
                />
              )}
            />
          </OrderContainer>
        </>
      )}
      {showCpfConfirm && (
        <ModalContainer
          title="⚠️ Emails não coincidem"
          content="Os emails não coincidem. Deseja preencher a classificação mesmo assim?"
          onClose={handleCloseCpfConfirm}
          sendCancel={handleConfirmCpfFill}
        />
      )}
    </HomeContainer>
  );
}